import { css } from "@compiled/react";

import Button from "@atlaskit/button";
import { B400 } from "@atlaskit/theme/colors";

import { fontSize } from "@/components/signup/utils";
import { wacToken } from "@/libraries/design/foundations";

export const ArrowLinkButton = ({
    onClick,
    text,
    isOnDarkBackground = false
}: {
    onClick: () => void;
    text: string;
    isOnDarkBackground?: boolean;
}) => {
    const buttonInnerCss = css({
        alignItems: "center",
        display: "flex",
        fontSize: fontSize.md,
        gap: 4,
        color: isOnDarkBackground ? wacToken("color.neutral.light0") : B400
    });

    return (
        <Button appearance="link" onClick={onClick}>
            <span css={buttonInnerCss}>
                {text}
                <svg
                    aria-hidden={true}
                    fill="currentColor"
                    height="8"
                    width="12"
                >
                    <path d="m7.908 0-1.08 1.202 1.75 1.948H1.264C.842 3.15.5 3.53.5 4c0 .469.342.85.763.85H8.58l-1.75 1.948L7.907 8 11.5 4 7.908 0Z" />
                </svg>
            </span>
        </Button>
    );
};
